// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/named */
import { takeLatest, spawn, put, select } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty, falsy } from 'utils/functions';
import { appActions, PRINT_RECEPTION_LABEL } from 'commons/reducer';
import { PROCESS_TYPES } from '../reducer';
import { t } from 'i18next';
import configureStore from 'config/configureStore';
import moment from 'moment';

function* getStateFromApi() {
  yield takeLatest(PROCESS_TYPES.GET_STATE_FROM_API, function* (action) {
    const response = yield apiRequest('api/v1/processTypes', { method: 'get' });
    yield put(apiSuccess(PROCESS_TYPES.GET_STATE_FROM_API_SUCCESS, response));
  });
}

function* createProcessTypeType() {
  yield takeLatest(PROCESS_TYPES.CREATE_PROCESS_TYPE, function* (action) {
    yield put(appActions.setLoader('create-edit-processTypeType', true));

    const response = yield apiRequest('api/v1/processTypes', {
      method: 'post',
      body: JSON.stringify(action.controls),
    });

    if (truthty(response.error)) {
      yield put(
        appActions.setError(
          `${t('processTypes.createError')} ${t(`processTypes.${response.errorMsg}`)}`,
        ),
      );
    } else {
      yield put(appActions.setSuccess(t('processTypes.createSuccess')));
      yield put(apiSuccess(PROCESS_TYPES.CREATE_PROCESS_TYPE_SUCCESS, response));
    }

    yield put(appActions.setLoader('create-edit-processTypeType', false));
  });
}

function* editProcessTypeType() {
  yield takeLatest(PROCESS_TYPES.EDIT_PROCESS_TYPE, function* (action) {
    yield put(appActions.setLoader('create-edit-processTypeType', true));
    const response = yield apiRequest(`api/v1/processTypes/${action.id}`, {
      method: 'put',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(PROCESS_TYPES.EDIT_PROCESS_TYPE_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-processTypeType', false));
  });
}

function* deleteProcessTypeType() {
  yield takeLatest(PROCESS_TYPES.DELETE_PROCESS_TYPE, function* (action) {
    yield put(appActions.setLoader('delete-processTypeType', true));
    const response = yield apiRequest(`api/v1/processTypes/${action.id}`, { method: 'delete' });
    if (falsy(response.error)) {
      const item = Object.values(response)[0];
      yield put(
        apiSuccess(PROCESS_TYPES.DELETE_PROCESS_TYPE_SUCCESS, { item, type: 'processTypes' }),
      );
    } else {
      yield put(appActions.setError(response.errorMsg));
    }
    yield put(appActions.setLoader('delete-processTypeType', false));
  });
}

function* exportProcessTypes() {
  yield takeLatest(PROCESS_TYPES.EXPORT_PROCESS_TYPE, function* (action) {
    yield put(appActions.setLoader('export-processTypes', true));
    const response = yield apiRequest(
      'api/v1/processTypes/export',
      { method: 'get' },
      false,
      'processTypes.xlsx',
    );
    yield put(apiSuccess(PROCESS_TYPES.EXPORT_PROCESS_TYPE_SUCCESS, response));
    yield put(appActions.setLoader('export-processTypes', false));
  });
}

function* updateLossPercentage() {
  yield takeLatest(PROCESS_TYPES.UPDATE_LOSS_PERCENTAGE, function* (action) {
    yield put(appActions.setLoader('update-loss-percentage', true));
    const response = yield apiRequest('api/v1/processTypes/loss', {
      method: 'put',
      body: JSON.stringify({
        percentage: action.percentage,
        processTypeIds: action.processTypeIds,
      }),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
      yield put(apiSuccess(PROCESS_TYPES.UPDATE_LOSS_PERCENTAGE_FAIL, response));
    } else {
      yield put(apiSuccess(PROCESS_TYPES.UPDATE_LOSS_PERCENTAGE_SUCCESS, response));
      yield put({ type: PROCESS_TYPES.GET_STATE_FROM_API });
    }
    yield put(appActions.setLoader('update-loss-percentage', false));
  });
}

function* getOperationalMasters() {
  yield takeLatest(PROCESS_TYPES.GET_OPERATIONAL_MASTERS, function* () {
    const response = yield apiRequest('api/v1/processTypes/operational-masters', { method: 'get' });

    if (!response?.error && response?.objects) {
      yield put(apiSuccess(PROCESS_TYPES.GET_OPERATIONAL_MASTERS_SUCCESS, response.objects));
    }
  });
}

function* getProcessTypes() {
  yield takeLatest(PROCESS_TYPES.GET_STATE_FROM_API, function* () {
    try {
      const response = yield apiRequest('api/v1/processTypes', { method: 'get' });

      if (truthty(response.error)) {
        yield put(appActions.setError(response.errorMsg));
      } else {
        yield put(apiSuccess(PROCESS_TYPES.GET_STATE_FROM_API_SUCCESS, response));
      }
    } catch (e) {
      yield put(appActions.setError('Error al cargar los tipos de proceso'));
    }
  });
}

function* createReceiptTrigger() {
  yield takeLatest(PROCESS_TYPES.CREATE_RECEIPT_TRIGGER, function* (action) {
    yield put(appActions.setLoader('create-receipt-trigger', true));

    const device = yield select((state) => state.app.device);
    const objects = yield select((state) => state.app.objects);
    const accountId = Object.values(objects?.accounts || {})[0]?.id;

    try {
      const processTypes = objects?.processTypes || {};
      const receptionPT = Object.values(processTypes).find((pt) => pt.name === 'Recepción');

      const user = yield select((state) => state.app.user);
      let harvester = 'Usuario Desconocido';

      if (user) {
        const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
        harvester = fullName || user.email || 'Usuario sin identificación';
      }

      if (receptionPT) {
        yield apiRequest(`api/v1/processTypes/${receptionPT.id}`, {
          method: 'put',
          body: JSON.stringify({
            name: receptionPT.name,
            nextProcessTypeId: action.controls.nextProcessTypeId,
            allowPakSubdivision: action.controls.splitPaks || false,
            autoCreateInboundPak: action.controls.outboundPak || false,
          }),
        });
      }

      const response = yield apiRequest('api/v1/receipts', {
        method: 'post',
        body: JSON.stringify({
          ...action.controls,
          lotNumber: moment().format('DDDDHHmm'),
          harvester,
        }),
      });

      if (truthty(response.error)) {
        yield put(appActions.setError(response.errorMsg));
      } else {
        yield put(appActions.setSuccess(t('processTypes.receipts_modal.toast_success')));
        yield put(apiSuccess(PROCESS_TYPES.CREATE_RECEIPT_TRIGGER_SUCCESS, response));

        if (response.zpl && device) {
          yield put({
            type: PRINT_RECEPTION_LABEL,
            device,
            allowPdfFallback: true,
            zpl: response.zpl,
            labelData: { accountId },
          });
        } else if (response.zpl && !device) {
          yield put(appActions.setError(t('processTypes.createSuccessNoPrinter')));
        }
      }
    } catch (e) {
      yield put(appActions.setError(t('apiError.default')));
      console.error(e);
    } finally {
      yield put(appActions.setLoader('create-receipt-trigger', false));
    }
  });
}

export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(deleteProcessTypeType);
  yield spawn(createProcessTypeType);
  yield spawn(editProcessTypeType);
  yield spawn(exportProcessTypes);
  yield spawn(updateLossPercentage);
  yield spawn(getOperationalMasters);
  yield spawn(createReceiptTrigger);
}
